import React, { useEffect, useState, Fragment } from "react";
import {
  Button,
  Stepper,
  Step,
  StepLabel,
  Grid,
  FormHelperText,
} from "@material-ui/core";
import axios from "helpers/API";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import { errorBackendMsg } from "helpers/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import Collapse from "@material-ui/core/Collapse";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
registerLocale("es", es);

const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  input100: {
    width: "100%",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

function Step1({ formik, setValidationSchema }) {
  const classes = useStyles();

  const [lugarOpt, setLugarOpt] = useState([]);
  const [servicioOpt, setServicioOpt] = useState([]);
  const [fechasDisponibles, setFechasDisponibles] = useState([]);
  const [fecha, setFecha] = useState(null);
  const [horasDisponibles, setHorasDisponibles] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [checked, setChecked] = React.useState(false);

  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);
  const [mensajeInfo, setMensajeInfo] = useState("");
  const [showInfo, setShowInfo] = useState(false);

  const validationSchema = Yup.object({
    servicioId: Yup.string().required("Campo Requerido"),
    fecha: Yup.string().required("Campo Requerido"),
    hora: Yup.string().required("Campo Requerido"),
  });

  useEffect(() => {
    setValidationSchema(validationSchema);
    listarLugares();
  }, []);

  useEffect(() => {
    if (formik.values.servicioId != "") {
      obtenerFechas(formik.values.servicioId);
    }
  }, [formik.values.servicioId]);

  const listarLugares = () => {
    axios
      .post("/generales/lugares/listarPorEtiqueta", {})
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          if (response.data.length == 1) {
            formik.setFieldValue("lugarId", response.data[0].value);
            listarServicio(response.data[0].value);
          }
          setLugarOpt(response.data);
          formik.setFieldValue("lugares", response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const listarServicio = (lugarId) => {
    if (!lugarId) {
      return;
    }
    axios
      .post("/generales/servicios/listarPorEtiqueta", {
        lugarId: lugarId,
      })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          if (response.data.length == 1) {
            formik.setFieldValue("servicioId", response.data[0].value);
            obtenerFechas(response.data[0].value);
          }
          setServicioOpt(response.data);
          setChecked(true);
          formik.setFieldValue("servicios", response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const obtenerFechas = (servicioId) => {
    axios
      .post("/programacionesDetalles/fechasDisponibles", {
        servicioId: servicioId,
      })
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          var fechas = [];
          response.data.fechas.forEach((fecha) => {
            var partes = fecha.split("/");
            var fechaDate = new Date(partes[2], partes[1] - 1, partes[0]);
            fechas.push(fechaDate);
          });

          setFechasDisponibles(fechas);

          if (fechas.length > 0) {
            formik.setFieldValue("fechaSel", fechas[0]);
            formik.setFieldValue("fecha", format(fechas[0], "dd/MM/yyyy"));
            setFecha(fechas[0]);
            obtenerHoras(format(fechas[0], "dd/MM/yyyy"), servicioId);
          }
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const obtenerHoras = (fecha, servicioId) => {
    formik.setFieldValue("hora", "");
    var consulta = {
      servicioId: servicioId,
      fecha: fecha,
    };

    axios
      .post("/programacionesDetalles/horasDisponibles", consulta)
      .then(function (response) {
        if (response.data.error && response.data.msg) {
          // msgErrorMsgBackend(response.data.msg);
        } else {
          formik.setFieldValue("horas", response.data);
          console.log(formik.values.horas);

          if (response.data.length == 1) {
            formik.setFieldValue("hora", response.data[0].value);
          }
        }
      })
      .catch(function (error) {
        // msgErrorMsgBackend(errorBackendMsg(error));
        // console.log(errorBackendMsg(error));
      });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <FormControl variant="outlined" className={classes.input100}>
            <InputLabel>Lugar</InputLabel>
            <Select
              variant="outlined"
              name="lugarId"
              id="lugarId"
              label="Lugar"
              onChange={(e) => {
                formik.handleChange(e);
                listarServicio(e.target.value);
              }}
              value={formik.values.lugarId}
              error={Boolean(formik.errors.lugarId) && formik.touched.lugarId}
            >
              {formik.values.lugares.map((lugar) => {
                return (
                  <MenuItem key={lugar.value} value={lugar.value}>
                    {lugar.label}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText error>
              {formik.errors.lugarId &&
                formik.touched.lugarId &&
                formik.errors.lugarId}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item md={6} xs={12}>
          <FormControl variant="outlined" className={classes.input100}>
            <InputLabel>Servicio</InputLabel>
            <Select
              variant="outlined"
              name="servicioId"
              id="servicioId"
              label="Servicio"
              onChange={formik.handleChange}
              value={formik.values.servicioId}
              error={
                Boolean(formik.errors.servicioId) && formik.touched.servicioId
              }
            >
              {formik.values.servicios.map((servicio) => {
                return (
                  <MenuItem key={servicio.value} value={servicio.value}>
                    {servicio.label}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText error>
              {formik.errors.servicioId &&
                formik.touched.servicioId &&
                formik.errors.servicioId}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid
          item
          md={6}
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Collapse in={formik.values.servicioId}>
            <DatePicker
              name="fecha"
              id="fecha"
              locale="es"
              variant="inline"
              inline
              format="dd/mm/yyyy"
              selected={formik.values.fechaSel}
              onChange={(date) => {
                formik.setFieldValue("fecha", format(date, "dd/MM/yyyy"));
                formik.setFieldValue("fechaSel", date);
                obtenerHoras(
                  format(date, "dd/MM/yyyy"),
                  formik.values.servicioId
                );
              }}
              includeDates={fechasDisponibles}
            />
      
          </Collapse>
        </Grid>
        <Grid item md={6} xs={12}>
          <Collapse in={formik.values.servicioId}>
            <FormControl variant="outlined" className={classes.input100}>
              <InputLabel>Hora</InputLabel>
              <Select
                variant="outlined"
                name="hora"
                id="hora"
                label="Hora"
                onChange={formik.handleChange}
                value={formik.values.hora}
                error={Boolean(formik.errors.hora) && formik.touched.hora}
              >
                {formik.values.horas.map((hora) => {
                  return (
                    <MenuItem key={hora.value} value={hora.value}>
                      {hora.label}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText error>
                {formik.errors.hora &&
                  formik.touched.hora &&
                  formik.errors.hora}
              </FormHelperText>
            </FormControl>
          </Collapse>
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={cargando}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default Step1;
